/* eslint-disable prettier/prettier */
import * as React from "react";
import { Grid, Tabs, Tab, Switch } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AmbulatoryDaily from "./AmbulatoryDaily";
import AmbulatoryWeek from "./AmbulatoryWeek";

interface Props {
  csrfToken: string;
  cgmActive: boolean;
  handleCgmActive: Function;
}
const ReportAmbulatory: React.FC<Props> = (props: any) => {
  const { csrfToken, cgmActive, handleCgmActive } = props;
  const [value, setValue] = React.useState(0);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`wrapped-tabpanel-${index}`}
        aria-labelledby={`wrapped-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Grid container className="ambulatory-report-container">
      <Grid item xs={12}>
        <Grid container className="tabs-container">
          <Grid container className="tabs-header-container">
            <Tabs
              value={value}
              onChange={handleChange}
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={
                {"& .MuiTabs-fixed": {
                  display: 'flex',
                  maxHeight: '44px'
              }}}
            >
              <Tab className="tabs-link" label="Daily" {...a11yProps(0)} />
              <Tab className="tabs-link" label="2 Week" {...a11yProps(1)} />
              <Tab className="tabs-link" label="4 Week" {...a11yProps(2)} />
            </Tabs>
            <Grid sx={{ display: "flex", marginLeft: "auto", color: "white" }}>
              <Switch
                checked={cgmActive}
                onChange={handleCgmActive}
                color="primary"
                sx={{ alignSelf: "center" }}
              />
              <p>CGM Patient Status: { cgmActive ? "Active" : "Inactive" }</p>
            </Grid>
          </Grid>

          <Grid item xs={12} className="tab-body-container">
            <TabPanel value={value} index={0}>
              <AmbulatoryDaily csrfToken={csrfToken} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <AmbulatoryWeek csrfToken={csrfToken} weekRange={2} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <AmbulatoryWeek csrfToken={csrfToken} weekRange={4} />
            </TabPanel>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReportAmbulatory;
